import { defineStore } from 'pinia';
import { getUserInfo_get, type getUserInfo_GET_res_type } from '~/api/p2p/p2p-user/p2p/user';
import { isLoginedToken } from '~/common/js/utils';
import { getMerchantInfo_post, type getMerchantInfo_POST_res_type } from '~/api/p2p/p2p-user/p2p/merchant';
import { getTradeAdInfo_post, createCheck_post as createCheck_ad, type getTradeAdInfo_POST_res_type } from '~/api/p2p/p2p-trade/p2p/ad';
import { useAccountStore } from './account';
import { createCheck_post, getStatistic_get, CANCEL_PIGEON_CODE } from '~/api/p2p/p2p-trade/p2p/order';
import { getToken_post } from '~/api/p2p/im-services';
import cloneShallow from 'lodash-es/clone';
import { p2pEventBus } from '~/utils/eventBus';

// import { useIndexStore } from './index';

type REMINDER_TYPE_Type = {
  [key: string]: string;
};

export const SUBSRCRIBE_TYPE = {
  // 委托单更新
  AD_UPDATE: 1,
  ORDER_PROCESSING_COUNT: 5,
  // 订单更新
  ORDER_UPDATE: 7,
  // 订单申诉更新
  ORDER_DISPUTE_UPDATE: 8,
  // 订单申诉单独更新（
  ORDER_DISPUTE_STATE_UPDATE: 9,
};

export const REMINDER_TYPE: REMINDER_TYPE_Type = {
  KYC_SYS: 'kyc-sys',
  KYC_BUSI: 'kyc-busi',
  '48106': 'adver-setted',
  '48003': 'account-suspended',
  // '48228': 'local-currency',
  KYC_UNIQUE: 'kyc_unique',
  '48114': 'kyc_unique_trade',
  '48239': 'kyc_unique_trade',
  KYC_UNIQUE_TRADE: 'kyc_unique_trade',
  '48319': 'risk_control',
  // [CANCEL_PIGEON_CODE]: 'cancel_pigeon',
};

export const REMINDER_ERROR_TYPE = {
  CANCEL_PIGEON_CODE: CANCEL_PIGEON_CODE,
  48228: 48228,
};

interface getMerchantInfo_type extends getMerchantInfo_POST_res_type {
  realNamePrivate: string;
}

export interface CheckOptionsForprepareTradeFlow {
  adId: string | number;
  cid: number;
  side: 'buy' | 'sell';
  currency: string;
  coinId: number;
  crypto: string;
  price?: string;
  size?: string;
  payType?: string;
  payAccountName?: string;
  payAccount?: string;
  payId: string;
}

// 暂未使用
const _SubscribeType = {
  SYS_AD_UPDATE: 1,
  SYS_AD_NEW:2,
  PENDING_ORDER_UPDATE: 3, // 进行中订单更新
  PENDING_ORDER_NEW: 4, // 进行中订单新增
  PENDING_ORDER_COUNT: 5, // 进行中订单数量更新
  ORDER_STATUS: 7, // 订单状态更新？
  ORDER_DISPUTE_STATUES: 8, // 订单申诉状态更新？
};

export const useP2pStore = defineStore('p2p', {
  state: () => ({
    // 交易信息
    tradeInfo: null as null | getTradeAdInfo_POST_res_type,
    // 交易对手详细用户信息
    tradeUserInfo: null as null | getMerchantInfo_type,
    // 显示交易窗口流程
    showTradeDialogFlow: false,
    // 用户信息
    userInfo: null as null | getUserInfo_GET_res_type,
    orderTip: 0, // 新订单提示
    orderPollingTimer: null,
    // imToken: null,

    // 错误提示
    reminderType: '' as any,
    reminderInfo: null as any,
    // 商家信息 -》当前用户作为商家的商家信息
    merchantInfo: null as null | getMerchantInfo_POST_res_type,

    // 盘口数据；diff 之后，更新当前页面（不在乎10条，全量更新）的展示；
    // 当前用户订单数据；
    // 
    systemAdBuyList: [], // 注意buy里是side==sell的
    systemAdSellList: [],

    myAdList: [], // 当前用户的委托单
    orderList: [], // 当前用户的订单
  }),
  // mutations: {
  //   updatePollResult(state, result) {
  //     state.pollResult = result;
  //   },
  // },
  actions: {
    setReminderType(type: string | number | null | undefined, payload?: any) {
      // console.log('setRe,omder', type);
      this.reminderType = type;
      this.reminderInfo = payload || null;
    },
    async getTradeUserInfo(cid: number) {
      if (!cid) return;
      
      const res = await getMerchantInfo_post({
        data: {
          merchantCId: cid,
          reqSource: 2,
        },
      });
      const info = res?.data;
      if (res?.success) {
        const privatPart = res.data.realName.slice(1);
        const privatPartArr = new Array(privatPart.length).fill('*');
        const realNamePrivate = res.data.realName.replace(privatPart, privatPartArr.join(''));
        Object.assign(info, {realNamePrivate}); 
        this.tradeUserInfo = { ...info };
      }
      return info;
    },
    async getMerchantInfo() {
      // 获取当前用户的merchant信息
      const accountStore = useAccountStore();
      if (accountStore.cid) {
        const res = await getMerchantInfo_post({
          data: {
            merchantCId: accountStore.cid,
            reqSource: 2,
          },
        });
        if (res?.success) {
          this.merchantInfo = res.data;
        }
      }
    },
    /**
     * 判断是否允许创建委托单
     * @param autoJump autoJump为true时，自动跳转至/create-ad；或执行cb；或什么都不做
     * @returns 
     */
    async checkCreateAd(autoJump?: boolean | Function | undefined){
    
      // let flag = false;
      const isLogined = await hasLogin();
      if (!isLogined) {
        return false;
        // gotoLogin;
      }
      // 必须登录；必须请求userInfo
      if (!this.userInfo) {
        await this.getP2pUserInfo();
      }
      if(!this.userInfo) {
        return false;
      }
      let successCb; 
      if(typeof autoJump === 'boolean' && autoJump){
        const router = useRouter();
        successCb = function(){
          router.push(`/p2p/create-ad`);
        };
      }else if (typeof autoJump === 'function'){
        successCb = autoJump;
      }

      // const kycLevel = this.userInfo.kycLevel;
      
      // 白名单只跳过kyc校验

      // KYC等级
      // if(!this.userInfo?.isWhiteList){
        // if(kycLevel !== 0 && kycLevel !== 1 && kycLevel !== 2){
        //   this.setReminderType(REMINDER_TYPE.KYC_UNIQUE);
        //   return false;
        // }
      // }
      
      const checkRes = await createCheck_ad();
      
      if (!checkRes.success && checkRes.code) {
        if (checkRes.code && REMINDER_TYPE[checkRes.code]) {
          this.setReminderType(REMINDER_TYPE[checkRes.code]);
        }
        if(Object.values(REMINDER_ERROR_TYPE).includes(checkRes.code)){
          this.setReminderType(checkRes.code, checkRes.data);
        }
        return false;
      }else{
        successCb?.();
      }
      return true;

    },
    // 开始买卖前的准备
    async prepareTradeFlow(options: CheckOptionsForprepareTradeFlow) {
      const adId = options.adId;
      const side = options.side;
      if (!adId || !side) return;
      const { cid, ...restOptions } = options;

      // p2p用户信息数据
      if (!this.userInfo) {
        await this.getP2pUserInfo();
      }

      // if (this.userInfo && !this.userInfo.isWhiteList && this.userInfo.kycLevel !== 2) {
      //   const kycLevel = this.userInfo.kycLevel;
      //   if (kycLevel < 2) {
      //     this.setReminderType(REMINDER_TYPE.KYC_SYS);

      //   } else {
      //     this.setReminderType(REMINDER_TYPE.KYC_UNIQUE_TRADE);
      //   }
      //   return;
      // }

      // 
      const createCheckRes = await createCheck_post({
        data: {
          ...restOptions,
        },
      });
      if (!createCheckRes.success && createCheckRes.code) {
        // this.setReminderType(REMINDER_TYPE.KYC_UNIQUE_TRADE);
        if (REMINDER_TYPE[createCheckRes.code]) {
          this.setReminderType(REMINDER_TYPE[createCheckRes.code]);
        }
        // 鸽子王
        if(Object.values(REMINDER_ERROR_TYPE).includes(createCheckRes.code)){
          this.setReminderType(createCheckRes.code, createCheckRes.data);
        }
        
        return;
      }

      // 钱包余额数据
      const accountStore = useAccountStore();
      if (accountStore.fiatWalletList.length < 1) {
        accountStore.getFiatBalance();
      }

      if (cid) {
        this.getTradeUserInfo(cid);
      }

      const adDetailRes = await getTradeAdInfo_post({
        data: {
          adId,
          side,
        },
      });
      if (adDetailRes.success) {
        this.tradeInfo = adDetailRes.data as getTradeAdInfo_POST_res_type;
      }
      // if (this.userInfo && this.tradeInfo && +this.userInfo.kycLevel < +this.tradeInfo.kycLevelLimit) {
      //   this.setReminderType(REMINDER_TYPE.KYC_BUSI);
      //   return;
      // }
      this.openTradeFlow();
    },
    openTradeFlow() {
      this.showTradeDialogFlow = true;
    },
    closeTradeFlow() {
      this.showTradeDialogFlow = false;
      this.tradeInfo = null;
      this.reminderType = '';
      this.tradeUserInfo = null;
    },
    async getUserInfo(forceRefresh?: boolean) {
      if(!forceRefresh && this.userInfo && this.userInfo.cid){
        return this.userInfo;
      }
      const res = await getUserInfo_get();
      if (res?.success) {
        this.userInfo = res.data;
      }
      return this.userInfo;
    },
    async getP2pUserInfo() {
      const res = await getUserInfo_get();
      if (res?.success) {
        this.userInfo = res.data;
      }
      return this.userInfo;
    },
    /**
     * header当前订单数量展示的轮询
     */
    startOrderPolling() {
      if (isLoginedToken()) {
        // const result = 
        getStatistic_get().then(res=>{
          this.orderTip = res?.data?.processingOrderCount || 0;
        });
      }
      // 已有ws推送，兜底改为3分钟查询一次
      const pollingTimer = setInterval(async()=>{
        if (isLoginedToken()) {
          const result = await getStatistic_get();
          this.orderTip = result?.data?.processingOrderCount || 0;
        }
      }, 3*60*1000);
      
      this.orderPollingTimer = pollingTimer as any;
    },
    stopOrderPolling() {
      // 清除定时器
      clearInterval(this.orderPollingTimer as any);
      this.orderPollingTimer = null;
    },
    clearTradeUserInfo(){
      // im
      this.tradeUserInfo = null;
    },
    async getToken() {
      const res = await getToken_post();
      if (res?.success) {
        this.imToken = res.data?.token;
      }
    },
    UPDATE_BY_SUBSCRIBE(payload: any){
      console.log("ws[p2p](store): 更新数据 >",payload);
      const { data = {} } = payload|| {};
      const { type, advertise} = data;
      // 根据远程订阅 更新；但是订阅消息返回的内容太多了，在这里对比分发
      
      // 进行中订单
      switch(type){
        case SUBSRCRIBE_TYPE.AD_UPDATE:
          const adInfo = advertise || {};
          // Tips: 密切注意数据格式不同的问题！推送的数据格式可能和原数据字段不对应；payTypeDesc
          if(adInfo?.payInfo){
            Object.assign(adInfo, {payTypeList: JSON.parse(adInfo?.payInfo)});
          }
          this.UPDATE_MY_AD_LIST(adInfo);
          this.UPDATE_ITEM_SYS_AD_LIST_BY_SIDE(adInfo);
          p2pEventBus.emit('updateHomeAdsDataBySubcribe', adInfo);
          p2pEventBus.emit('updateAdBooksBySubcribe', adInfo);
          break;
        case SUBSRCRIBE_TYPE.ORDER_PROCESSING_COUNT:
          
          if(data?.processingOrderCount > this.orderTip){
            p2pEventBus.emit('refreshProcessingOrderListBySubcribe', data.order);
          }
          if(data?.processingOrderCount !== this.orderTip){
            this.orderTip = data?.processingOrderCount || 0;
            // getStatistic_get().then(res=>{
            //   this.orderTip = res?.data?.processingOrderCount || 0;
            // });
            
          }
          break;
        case SUBSRCRIBE_TYPE.ORDER_UPDATE:
        case SUBSRCRIBE_TYPE.ORDER_DISPUTE_UPDATE:
          
          p2pEventBus.emit('updateMyOrderBySubcribe', data.order);
          p2pEventBus.emit('updateOrderListBySubcribe', data.order);
          
          break;
        case SUBSRCRIBE_TYPE.ORDER_DISPUTE_STATE_UPDATE:
          p2pEventBus.emit('updateDisputeBySubcribe', data?.order||{});
          break;
      }
      // 进行中数量增加，不会触发order的状态改变推送（新增订单不推）但是要触发列表刷新
      
      //  data.type = SubscribeType.PENDING_ORDER_UPDATE
        // 当前搜索条件不符合前端过滤要求的时候
    },
    // home-page ad-list
    SET_SYS_AD_LIST_BY_SIDE({list, side}:{list: any, side:string}){
      if(side ==='buy'){
        this.systemAdBuyList = list; // should be:side === sell
      }else{
        this.systemAdSellList = list;
      }
    },
    UPDATE_ITEM_SYS_AD_LIST_BY_SIDE(data: any){
      const newBuyList = cloneShallow(this.systemAdBuyList) as any;
      const newSellList = cloneShallow(this.systemAdSellList) as any;

      let buyChangeFlag = false;
      let sellChangeFlag = false;
      
      newBuyList?.forEach((element: any, index: number) => {
        if(element.adId === data.adId){
          newBuyList[index] = {...element, ...data};
          buyChangeFlag = true;
        }
      })?.filter((item:any)=> item?.state !=='inActive');

      newSellList?.forEach((element:any, index: number) => {
        if(element.adId === data.adId){
          newSellList[index] = {...element, ...data};
          sellChangeFlag = true;
        }
      });

      if(buyChangeFlag){
        this.systemAdBuyList = newBuyList?.filter((item:any)=> item?.state !=='inActive');
      }

      if(sellChangeFlag){
        this.systemAdSellList = newSellList?.filter((item:any)=> item?.state !=='inActive');
      }
      
    },
    // ads-manage
    SET_MINE_AD_LIST(data: any){
      this.myAdList = cloneShallow(data);
    },
    UPDATE_MY_AD_LIST(data: any){
      if(!this.myAdList?.length){
        return;
      }

      const newlist = cloneShallow(this.myAdList) as any;
      let updateFlag = false;
      newlist?.forEach((oldItem:any,index:number)=>{
        if(oldItem.adId === data.adId){
          newlist[index] = Object.assign({},oldItem, data);
          console.log("ws: 更新item", newlist[index]);
          updateFlag = true;
        }
      });
      if(updateFlag){
        this.myAdList = newlist;
      }
    },
    SET_ORDER_LIST(data){
      this.orderList = data;
    },
    UPDATE_ORDER_LIST(data){
      // 1. 检查当前订单是否在进行中列表中，如果在当前页，
      // 当前订单状态 是否不在进行中了，回到首页；

      // clone a array
      // then update orderList
    }
    // /** 设置注册/换绑等国家列表 */
    // SET_REG_COUNTRY_LIST(countryList) {
    //   this.regCountryList = countryList;
    // },
    // /** 设置kyc国家列表 */
    // SET_KYC_COUNTRY_LIST(kycCountryList) {
    //   this.kycCountryList = kycCountryList;
    // },
    // /** 设置全部国家列表 */
    // SET_ALL_COUNTRY_LIST(allCountryList) {
    //   this.allCountryList = allCountryList;
    // },
    // /** 设置有区号的国家列表 */
    // SET_ALL_AREA_CODE_LIST(allAreaCodeList) {
    //   this.allAreaCodeList = allAreaCodeList;
    // },
  },
});
